<template>
  <b-row align-h="center">
    <b-col cols xl="12" class="col-xxl-9">
      <b-form>
        <b-form-group label="Naslov">
          <b-form-input v-model="article.title" size="lg" />
        </b-form-group>
        <b-form-group label="Opis">
          <b-form-textarea
            v-model="article.short"
            rows="3"
            max-rows="6"
            placeholder="Kratak opis..."
          />
        </b-form-group>
        <b-form-group label="Ceo tekst">
          <ckeditor :editor="editor" ref="ckeditor" v-model="fullText" :config="editorConfig"></ckeditor>
        </b-form-group>
        <b-form-group label="Ključne reči">
          <b-form-input v-model="keywords" size="md" placeholder="ključne reči razdvojite zarezom" />
        </b-form-group>
        <b-form-group label="Galerija">
          <UploadDrop
            ref="uploadDrop"
            :options="uploadDropOptions"
            v-on:uploadingEvent="uploadingEvent"
            v-on:completedEvent="completedEvent"
            v-on:removedEvent="removedEvent"
          />
        </b-form-group>
        <b-form-group>
          <b-button variant="success" size="md" class="mr-auto" @click="save">
            <i class="fas fa-paper-plane"></i>
            Pošalji
          </b-button>
          <b-button variant="secondary" class="float-right" :to="{name:'news'}">Odustani</b-button>
        </b-form-group>
      </b-form>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import config from "@/config";
import UploadDrop from "@/components/UploadDrop";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  components: {
    UploadDrop
  },
  data() {
    return {
      cover: null,
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "bulletedList",
          "numberedList",
          "|",
          "link",
          "blockQuote",
          "|",
          "undo",
          "redo"
        ]
      }
    };
  },
  created() {
    this.getArticle(this.$route.params.article_id)
      .then(() => {
        this.$store.commit("addCrumb", {
          text: this.article.title,
          to: { name: "edit_news", params: { id: this.article.id } },
          active: true
        });
        this.$refs.uploadDrop.reset();
        this.article.images.forEach(img => {
          this.$refs.uploadDrop.addFile({
            src: config.RESOURCE_URL + img.path,
            id: img.id
          });
        });
      })
      .catch();
  },

  computed: {
    ...mapGetters({ article: "news/current", token: "auth/token" }),
    images() {
      return this.article.images || [];
    },
    fullText: {
      set(newVal) {
        this.article.full = newVal;
      },
      get() {
        return this.article.full || "";
      }
    },
    keywords: {
      set(newVal) {
        this.article.keywords = newVal;
      },
      get() {
        return this.article.keywords || "";
      }
    },
    uploadDropOptions() {
      return {
        url: config.API_URL + "/images",
        headers: {
          Authorization: "Bearer " + this.token
        },
        items: this.images.map(item => {
          return {
            id: item.id,
            src: config.RESOURCE_URL + item.path
          };
        }),
        thumbnailWidth: 200
      };
    }
  },

  methods: {
    ...mapActions({
      getArticle: "news/fetchArticle",
      saveArticle: "news/saveArticle",
      removeImage: "news/removeImage"
    }),

    save() {
      this.saveArticle()
        .then(() => {
          this.$router.push({ name: "news" });
        })
        .catch();
    },
    sendingEvent(file, xhr, formData) {
      formData.append("article", this.article.id);
    },
    completedEvent(file, response) {
      file.src = config.RESOURCE_URL + response.path;
      file.id = response.id;
    },
    removedEvent(id) {
      //console.log(idx);
      this.removeImage(id)
        .then()
        .catch(err => console.log(err));
    },
    uploadingEvent(file, formData) {
      formData.append("article", this.article.id);
    }
  }
};
</script>

<style lang="scss">
.ck-editor__editable {
  min-height: 300px;
  max-height: 700px;
}
</style>